var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          ref: "cargoLeftRightResize",
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": { flex: "none", "max-width": "190px" },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c("cargo-ag-grid", {
                staticClass: "section grid-fill",
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.rowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "cargo-button-group-slider",
                        { ref: "cargoButtonGroupSlider" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.action === "look",
                                  expression: "action==='look'"
                                }
                              ],
                              class:
                                "btn-group-look" +
                                (_vm.canOperateJob ? "" : " cannot-operate-job")
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "can-operate",
                                  attrs: { no: "back", type: "primary" },
                                  on: {
                                    click: function($event) {
                                      _vm.backEventFlag = true
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.back")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled: !(
                                      Number(_vm.currentRow.jobState) === 0 &&
                                      !_vm.JobUtils.isBlockJob(_vm.currentRow)
                                    ),
                                    no: "edit",
                                    type: "success"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.editEventFlag = true
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.edit")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$checkPermission([
                                        "button_AIBooking_addAIBooking"
                                      ]),
                                      expression:
                                        "$checkPermission(['button_AIBooking_addAIBooking'])"
                                    }
                                  ],
                                  attrs: { no: "Copy", type: "primary" },
                                  on: { click: _vm.toCopy }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Copy")))]
                              ),
                              _c(
                                "el-upload",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    "margin-left": "5px"
                                  },
                                  attrs: {
                                    no: "PaymentInformationImport",
                                    disabled: !_vm.canOperateJob,
                                    action: _vm.actionUrl,
                                    headers: {
                                      sessionId: _vm.context.user.sessionId
                                    },
                                    "show-file-list": false,
                                    accept: ".csv",
                                    "before-upload": _vm.beforeUpload,
                                    "on-success": _vm.uploadSuccess
                                  }
                                },
                                [
                                  _c(
                                    "el-button",
                                    { attrs: { type: "primary" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "SeaExport.PaymentInformationImport"
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$checkPermission([
                                        "button_AIBooking_addAIBooking"
                                      ]),
                                      expression:
                                        "$checkPermission(['button_AIBooking_addAIBooking'])"
                                    }
                                  ],
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "new",
                                    disabled: _vm.hqDisabledOperate,
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toAdd()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.new")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$checkPermission([
                                        "button_AIBooking_addLCL"
                                      ]),
                                      expression:
                                        "$checkPermission(['button_AIBooking_addLCL'])"
                                    }
                                  ],
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "AddHbl",
                                    disabled: _vm.hqDisabledOperate,
                                    type: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.toAdd({ masterFlag: true })
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.AddHbl")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.printVisible,
                                      expression: "printVisible"
                                    }
                                  ],
                                  attrs: { no: "print", type: "success" },
                                  on: { click: _vm.onPrint }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.$checkPermission([
                                          "button_JobBooking_ReturnReview"
                                        ]) && _vm.showReturnReview,
                                      expression:
                                        "$checkPermission(['button_JobBooking_ReturnReview']) && showReturnReview"
                                    }
                                  ],
                                  attrs: {
                                    no: "returnReview",
                                    type: "primary"
                                  },
                                  on: { click: _vm.returnReview }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_ReturnPreApprovalRemoteBooking"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _vm.shutoutButtonVisible
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        no: "toShutOut",
                                        type: "primary",
                                        disabled:
                                          !(
                                            _vm.currentRow.jobState ===
                                              _vm.SystemConstants.OPERATING ||
                                            _vm.currentRow.jobState ===
                                              _vm.SystemConstants.SHUT_OUT
                                          ) || _vm.isCooperate
                                      },
                                      on: { click: _vm.toShutOut }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentRow.shutOut
                                            ? _vm.$t("SeaExport.CancelInvalid")
                                            : _vm.$t("SeaExport.Invalid")
                                        )
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  staticClass: "can-operate",
                                  attrs: {
                                    type: "primary",
                                    disabled: !_vm.currentRow.trustFromJob
                                  },
                                  on: { click: _vm.queryTrustFrom }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "SeaExport.AssociationBusinessInformation"
                                      )
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$checkPermission([
                                        "button_JobBooking_PrintProfit"
                                      ]),
                                      expression:
                                        "$checkPermission(['button_JobBooking_PrintProfit'])"
                                    }
                                  ],
                                  attrs: {
                                    no: "PrintProfitAnalysis",
                                    type: "primary"
                                  },
                                  on: { click: _vm.printProfitEventHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.PrintProfitAnalysis")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.preSubmitVisible,
                                      expression: "preSubmitVisible"
                                    }
                                  ],
                                  attrs: {
                                    no: "PreSubmission",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.doPreSubmit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PreSubmission"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.submitVisible,
                                      expression: "submitVisible"
                                    }
                                  ],
                                  attrs: {
                                    no: "Submission",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.doSubmit }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Submission")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.managerSubmitVisible,
                                      expression: "managerSubmitVisible"
                                    }
                                  ],
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "ManagerSubmission",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.doManagerSubmit }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.ManagerSubmission")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.submitAuditVisible,
                                      expression: "submitAuditVisible"
                                    }
                                  ],
                                  attrs: {
                                    no: "Audit",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.doSubmitAudit_ManagerSubmit }
                                },
                                [_vm._v(_vm._s(_vm.$t("SeaExport.Audit")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.printReturnOperateVisible,
                                      expression: "printReturnOperateVisible"
                                    }
                                  ],
                                  attrs: {
                                    no: "ReturnAction",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.backReturn }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ReturnAction"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.printReturnVisible,
                                      expression: "printReturnVisible"
                                    }
                                  ],
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "PrintReturn",
                                    type: "primary",
                                    disabled: _vm.isCooperate
                                  },
                                  on: { click: _vm.backReturn }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.PrintReturn"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.useOrderCenterMode &&
                                        !_vm.masterFlag &&
                                        (!_vm.orderCenterBranch ||
                                          (_vm.orderCenterBranch &&
                                            _vm.useOrderCenterBranch &&
                                            !_vm.isRegionalCommission)),
                                      expression:
                                        "useOrderCenterMode && !masterFlag && (!orderCenterBranch || (orderCenterBranch && useOrderCenterBranch) && !isRegionalCommission)"
                                    }
                                  ],
                                  attrs: {
                                    no: "bntCooperation",
                                    type: "primary"
                                  },
                                  on: { click: _vm.cooperationHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("CargoMsg.Cargo_Cooperation"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.useOrderCenterMode &&
                                        !_vm.masterFlag &&
                                        !_vm.orderCenterBranch,
                                      expression:
                                        "useOrderCenterMode && !masterFlag && !orderCenterBranch"
                                    }
                                  ],
                                  attrs: {
                                    no: "bntCooperationReturn",
                                    type: "primary"
                                  },
                                  on: { click: _vm.cooperationReturnHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_CooperationReturn")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        _vm.currentRow.jobState ===
                                          _vm.SystemConstants.VERIFIED &&
                                        _vm.currentRow.changeState ===
                                          _vm.SystemConstants.VERIFIED &&
                                        _vm.$checkPermission([
                                          "button_JobBooking_ChangeCommit"
                                        ]) &&
                                        _vm.isCommittedAllowAddCost,
                                      expression:
                                        "currentRow.jobState === SystemConstants.VERIFIED && currentRow.changeState === SystemConstants.VERIFIED && $checkPermission(['button_JobBooking_ChangeCommit']) && isCommittedAllowAddCost"
                                    }
                                  ],
                                  attrs: {
                                    no: "ChangeCommit",
                                    type: "primary"
                                  },
                                  on: { click: _vm.changeCommit_clickHandler }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ChangeCommit"))
                                  )
                                ]
                              ),
                              _c(
                                "el-dropdown",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.$checkPermission([
                                        "tab_Charge_chargeView"
                                      ]),
                                      expression:
                                        "$checkPermission(['tab_Charge_chargeView'])"
                                    }
                                  ],
                                  staticStyle: { margin: "0 5px" },
                                  attrs: {
                                    no: "chargeHandle",
                                    "split-button": "",
                                    type: "primary"
                                  },
                                  on: {
                                    click: _vm.chargeHandle,
                                    command: function(p) {
                                      _vm.chargeCommand = p
                                      _vm.chargeHandle()
                                    }
                                  }
                                },
                                [
                                  _vm._v(" " + _vm._s(_vm.chargeCommand) + " "),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: _vm.$t(
                                              "SeaExport.AddCharges"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SeaExport.AddCharges")
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: _vm.$t(
                                              "SeaExport.ChargeImport"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SeaExport.ChargeImport")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-dropdown",
                                {
                                  staticClass: "can-operate",
                                  attrs: {
                                    no: "logHandle",
                                    "split-button": "",
                                    type: "primary"
                                  },
                                  on: {
                                    click: _vm.logHandle,
                                    command: function(p) {
                                      _vm.logCommand = p
                                      _vm.logHandle()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_LogRecord")
                                      ) +
                                      " "
                                  ),
                                  _c(
                                    "el-dropdown-menu",
                                    {
                                      attrs: { slot: "dropdown" },
                                      slot: "dropdown"
                                    },
                                    [
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: _vm.$t(
                                              "CargoMsg.Cargo_BusinessStatusChangeLog"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_BusinessStatusChangeLog"
                                              )
                                            )
                                          )
                                        ]
                                      ),
                                      _c(
                                        "el-dropdown-item",
                                        {
                                          attrs: {
                                            command: _vm.$t(
                                              "SeaExport.OperationLog"
                                            )
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("SeaExport.OperationLog")
                                            )
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.isNew || _vm.action === "edit",
                                  expression: "isNew||action==='edit'"
                                }
                              ],
                              staticClass: "btn-group-edit",
                              staticStyle: {
                                "border-left": "none",
                                "padding-left": "0"
                              }
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "save",
                                    type: "success",
                                    disabled: _vm.context.loading
                                  },
                                  on: { click: _vm.save }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "cancel",
                                    type: "success",
                                    disabled: _vm.context.loading
                                  },
                                  on: { click: _vm.cancelEdit }
                                },
                                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    no: "SaveTheDefaultValues",
                                    type: "primary"
                                  },
                                  on: { click: _vm.saveDefaultVal }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t("SeaExport.SaveTheDefaultValues")
                                    )
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.action === "edit",
                                      expression: "action==='edit'"
                                    }
                                  ],
                                  staticStyle: {
                                    "font-size": "12px",
                                    color: "unset"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.stateInfo.customer))]
                              ),
                              _c("span", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.action === "edit",
                                    expression: "action==='edit'"
                                  }
                                ],
                                staticStyle: {
                                  "font-size": "12px",
                                  color: "unset"
                                },
                                domProps: {
                                  innerHTML: _vm._s(_vm.commonInfo.jobTitle)
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.action === "look",
                              expression: "action==='look'"
                            }
                          ],
                          staticStyle: {
                            "white-space": "nowrap",
                            display: "flex"
                          }
                        },
                        [
                          _c("CargoIm", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.imCacheKey && _vm.action === "look",
                                expression: "imCacheKey && action==='look'"
                              }
                            ],
                            ref: "cargoIm"
                          }),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                content:
                                  _vm.action === "edit"
                                    ? ""
                                    : _vm.$t("SeaExport.Tip1"),
                                placement: "bottom-start",
                                offset: _vm.sopTooltipOffset,
                                "visible-arrow": false
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "100%",
                                    cursor: "pointer"
                                  },
                                  on: {
                                    mousemove: _vm.resetSopTooltip,
                                    dblclick: _vm.onBtnListDoubleClicked
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "red",
                                        padding: "5px 0"
                                      },
                                      attrs: { no: "SopState" }
                                    },
                                    [_vm._v(_vm._s(_vm.stateInfo.jobState))]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.isCommittedAllowAddCost,
                                          expression: "isCommittedAllowAddCost"
                                        }
                                      ],
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "red",
                                        padding: "5px 0 5px 9px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.stateInfo.jobChangeState)
                                      )
                                    ]
                                  ),
                                  _vm.job.payableChargeLockedStatus === 1
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "14px",
                                            color: "red",
                                            padding: "5px 0 5px 9px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "CargoMsg.Cargo_PayableLockedStatusTag"
                                              )
                                            )
                                          ),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "dark",
                                                content:
                                                  _vm.payableChargeLockedTooltip,
                                                placement: "bottom",
                                                "visible-arrow": false
                                              }
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-warning",
                                                staticStyle: {
                                                  cursor: "pointer"
                                                }
                                              })
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        padding: "5px 9px",
                                        color: "unset"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.stateInfo.jobNo))]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.aiHeaderShowTitleMblMid,
                                          expression: "aiHeaderShowTitleMblMid"
                                        }
                                      ],
                                      staticStyle: {
                                        "font-size": "12px",
                                        padding: "5px 9px",
                                        color: "unset"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.stateInfo.titleMblMid))]
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-size": "12px",
                                        color: "unset"
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.stateInfo.customer))]
                                  ),
                                  _c("span", {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "unset"
                                    },
                                    domProps: {
                                      innerHTML: _vm._s(_vm.commonInfo.jobTitle)
                                    }
                                  }),
                                  _vm.commonInfo.provisionLock &&
                                  _vm.commonInfo.provisionLock.etdLocked
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "14px",
                                            color: "red",
                                            "margin-left": "10px"
                                          }
                                        },
                                        [_vm._v("计提已校准")]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          ),
                          _vm.currentRow.zyCreditWarning
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.currentRow.zyCreditWarning,
                                    placement: "bottom-start",
                                    "visible-arrow": false
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "right-tip",
                                      staticStyle: {
                                        cursor: "pointer",
                                        "font-size": "12px",
                                        color: "orange",
                                        width: "200px",
                                        overflow: "hidden",
                                        "text-overflow": "ellipsis",
                                        "white-space": "nowrap"
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.currentRow.zyCreditWarning)
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  class:
                    "tabs-container" +
                    (_vm.canOperateJob ? "" : " cannot-operate-job")
                },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "card",
                        "before-leave": function(activeName, oldActiveName) {
                          _vm.beforeLeaveTab(activeName, oldActiveName)
                        }
                      },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      !_vm.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 1,
                              attrs: {
                                lazy: true,
                                name: "tabBookingFCL",
                                label: _vm.$t("SeaExport.AirOperation")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-booking-FCLUICustom", {
                                    ref: "tabBookingFCL",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      resetData: _vm.resetData,
                                      updateJob: _vm.updateJob
                                    }
                                  })
                                : _c("tab-booking-fcl", {
                                    ref: "tabBookingFCL",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "processing-promise-list":
                                        _vm.processingPromiseList,
                                      "template-name": _vm.templateName
                                    },
                                    on: {
                                      resetTab: _vm.resetTab,
                                      resetData: _vm.resetData,
                                      updateJob: _vm.updateJob
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 2,
                              attrs: {
                                lazy: true,
                                name: "tabBookingMaster",
                                label: _vm.$t("SeaExport.MblInfo")
                              }
                            },
                            [
                              _vm.$store.state.uiCustom.enable
                                ? _c("tab-booking-master-UICustom", {
                                    ref: "tabBookingMaster",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "view-source": "bookingWorkspace",
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "template-name": _vm.templateName,
                                      "provision-lock":
                                        _vm.commonInfo.provisionLock
                                    },
                                    on: {
                                      addLcl: _vm.addBatchLcl,
                                      selectJob: _vm.transferTargetRow,
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      resetTab: _vm.resetTab,
                                      resetData: _vm.resetData
                                    }
                                  })
                                : _c("tab-booking-master", {
                                    ref: "tabBookingMaster",
                                    attrs: {
                                      context: _vm.context,
                                      action: _vm.action,
                                      "view-source": "bookingWorkspace",
                                      "cooperate-edit": _vm.cooperateEditOther,
                                      "template-name": _vm.templateName,
                                      "provision-lock":
                                        _vm.commonInfo.provisionLock
                                    },
                                    on: {
                                      addLcl: _vm.addBatchLcl,
                                      selectJob: _vm.transferTargetRow,
                                      addSlavedJob: _vm.addSlavedJob,
                                      removeJobFromMaster:
                                        _vm.removeJobFromMaster,
                                      resetTab: _vm.resetTab,
                                      resetData: _vm.resetData
                                    }
                                  })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.masterFlag && _vm.paramsOfTab.usCustomsClearance
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabUsCustomsClearance",
                              attrs: {
                                lazy: true,
                                name: "tabUsCustomsClearance",
                                label: _vm.$t("queryJob.UsCustomsClearance")
                              }
                            },
                            [
                              _c("tab-us-customs-clearance", {
                                ref: "tabUsCustomsClearance",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.masterFlag && _vm.paramsOfTab.usCustomsClearance
                        ? _c(
                            "el-tab-pane",
                            {
                              key: "tabUsCustomsClearanceMaster",
                              attrs: {
                                lazy: true,
                                name: "tabUsCustomsClearanceMaster",
                                label: _vm.$t("queryJob.UsCustomsClearance")
                              }
                            },
                            [
                              _c("tab-us-customs-clearance-master", {
                                ref: "tabUsCustomsClearanceMaster",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          key: 3,
                          attrs: {
                            lazy: true,
                            name: "tabTradeDetail",
                            label: _vm.$t("SeaExport.TradeDetail")
                          }
                        },
                        [
                          _c("tab-trade-detail", {
                            ref: "tabTradeDetail",
                            attrs: {
                              context: _vm.context,
                              action: _vm.action,
                              "cooperate-edit": _vm.cooperateEditOther
                            },
                            on: { syncData: _vm.syncData }
                          })
                        ],
                        1
                      ),
                      _vm.paramsOfTab.uuid && _vm.paramsOfTab.itmService
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 4,
                              attrs: {
                                lazy: true,
                                name: "tabTradeCommission",
                                label: _vm.$t("SeaExport.TradeCommission")
                              }
                            },
                            [
                              _c("tab-trade-commission", {
                                ref: "tabTradeCommission",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                },
                                on: { syncData: _vm.syncData }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      (_vm.masterFlag ||
                        _vm.paramsOfTab.operateType === 1 ||
                        _vm.paramsOfTab.operateType === 2) &&
                      _vm.paramsOfTab.uuid
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 15,
                              attrs: {
                                lazy: true,
                                name: "tabMAWB",
                                label: _vm.$t("SeaExport.MBLInfo")
                              }
                            },
                            [
                              _c("tab-mawb", {
                                ref: "tabMAWB",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.operateType !== 1 &&
                      !_vm.masterFlag &&
                      _vm.paramsOfTab.uuid
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 5,
                              attrs: {
                                lazy: true,
                                name: "tabHbl",
                                label: _vm.$t("SeaExport.HblInfo")
                              }
                            },
                            [
                              _c("tab-hbl", {
                                ref: "tabHbl",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.$checkPermission(["tab_Charge_chargeView"])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 6,
                              attrs: {
                                lazy: true,
                                name: "tabCharges",
                                label: _vm.$t("SeaExport.Charge")
                              }
                            },
                            [
                              _c("tab-charges", {
                                ref: "tabCharges",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  location: _vm.location,
                                  "view-source": "AiBooking",
                                  "provision-lock": _vm.commonInfo.provisionLock
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.uuid &&
                      _vm.$checkPermission([
                        "tab_ChargeConfirm_chargeConfirmView"
                      ])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 7,
                              attrs: {
                                lazy: true,
                                name: "tabInternalBill",
                                label: _vm.$t("SeaExport.InternalBillInfo")
                              }
                            },
                            [
                              _c("tab-internal-bill", {
                                ref: "tabInternalBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  location: _vm.location
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.uuid &&
                      _vm.$checkPermission(["tab_billTab_billTabView"])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 8,
                              attrs: {
                                lazy: true,
                                name: "tabOverseaBill",
                                label: _vm.$t("SeaExport.OverseaBillInfo")
                              }
                            },
                            [
                              _c("tab-oversea-bill", {
                                ref: "tabOverseaBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  location: _vm.location,
                                  "view-source": "AiBooking"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      Boolean(_vm.paramsOfTab.uuid)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 9,
                              attrs: {
                                lazy: true,
                                name: "tabAdvanceCharge",
                                label: _vm.$t("SeaExport.AdvanceChargeInfo")
                              }
                            },
                            [
                              _c("tab-advance-charge", {
                                ref: "tabAdvanceCharge",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  location: _vm.location
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.masterFlag &&
                      _vm.paramsOfTab.uuid &&
                      _vm.paramsOfTab.customs
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 10,
                              attrs: {
                                lazy: true,
                                name: "tabCustomsInfo",
                                label: _vm.$t("SeaExport.CustomsDeclaration")
                              }
                            },
                            [
                              _c("tab-customs-info", {
                                ref: "tabCustomsInfo",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditCustoms
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.paramsOfTab.insure
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                lazy: true,
                                name: "tabInsure",
                                label: _vm.$t("SeaExport.InsureInfo")
                              }
                            },
                            [
                              _c("tab-insure", {
                                ref: "tabInsure",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.masterFlag && _vm.paramsOfTab.uuid
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 11,
                              attrs: {
                                lazy: true,
                                name: "tabFile",
                                label: _vm.$t("SeaExport.DocumentCirculation")
                              }
                            },
                            [
                              _c("tab-file", {
                                ref: "tabFile",
                                attrs: {
                                  context: _vm.context,
                                  "cooperate-edit": _vm.cooperateEditOther
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.masterFlag && _vm.paramsOfTab.uuid
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 12,
                              attrs: {
                                lazy: true,
                                name: "tabLocalService",
                                label: _vm.$t("SeaExport.LocalService")
                              }
                            },
                            [
                              _c("tab-local-service", {
                                ref: "tabLocalService",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit-warehouse":
                                    _vm.cooperateEditWarehouse,
                                  "cooperate-edit-trucking":
                                    _vm.cooperateEditTrucking
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isNew &&
                      _vm.paramsOfTab.uuid &&
                      !_vm.masterFlag &&
                      _vm.$checkPermission(["tab_AIBooking_portalState"])
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 13,
                              attrs: {
                                lazy: true,
                                name: "tabSopState",
                                label: _vm.$t("SeaExport.BusinessStatus")
                              }
                            },
                            [
                              _c("tab-sop-state", {
                                ref: "tabSopState",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "sop-template-config": _vm.sopTemplateConfig
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      Boolean(_vm.paramsOfTab.uuid)
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 14,
                              attrs: {
                                lazy: true,
                                name: "tabFileHistory",
                                label: _vm.$t("SeaExport.FileHistory")
                              }
                            },
                            [
                              _c("tab-file-history", {
                                ref: "tabFileHistory",
                                attrs: {
                                  context: _vm.context,
                                  "cooperate-edit": _vm.cooperateEditOther,
                                  "can-operate-job": _vm.canOperateJob
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: "RE",
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.checkingWindow.visible
        ? _c("checking-window", {
            attrs: {
              visible: _vm.checkingWindow.visible,
              lob: "RE",
              job: _vm.currentRow,
              "check-node": _vm.checkingWindow.checkNode,
              "call-back": _vm.checkingWindow.callBack,
              "call-back2": _vm.checkingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.addChargeDetailDialog.visible
        ? _c("add-charge-detail-dialog", {
            attrs: {
              visible: _vm.addChargeDetailDialog.visible,
              "selected-jobs": _vm.addChargeDetailDialog.selectedJobs,
              location: _vm.location,
              lob: "AI",
              "selected-scheme": _vm.addChargeDetailDialog.selectedScheme
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.addChargeDetailDialog, "visible", $event)
              },
              toChangeSchema: _vm.toChangeSchema
            }
          })
        : _vm._e(),
      _vm.chargeSchemeBatchDialog.visible
        ? _c("charge-scheme-batch-dialog", {
            attrs: {
              visible: _vm.chargeSchemeBatchDialog.visible,
              "selected-jobs": _vm.chargeSchemeBatchDialog.selectedJobs,
              job: _vm.chargeSchemeBatchDialog.job,
              lob: _vm.chargeSchemeBatchDialog.lob,
              "is-sea": _vm.chargeSchemeBatchDialog.isSea,
              "original-condition":
                _vm.chargeSchemeBatchDialog.originalCondition,
              "charge-scheme-is-approved":
                _vm.chargeSchemeBatchDialog.chargeSchemeIsApproved,
              location: _vm.location,
              "charge-type": _vm.chargeSchemeBatchDialog.chargeType,
              source: _vm.chargeSchemeBatchDialog.source
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.chargeSchemeBatchDialog, "visible", $event)
              },
              selectedSchemeHandler: _vm.handleSelectedScheme
            }
          })
        : _vm._e(),
      _vm.businessStatusDialog.visible
        ? _c("business-status-log-dialog", {
            attrs: {
              visible: _vm.businessStatusDialog.visible,
              "job-uuid": _vm.currentRow.uuid || ""
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.businessStatusDialog, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("sop-state-dialog", {
        attrs: {
          "hide-window": _vm.action !== "look",
          visible: _vm.sopStateDialog.visible,
          "is-need-refresh": _vm.sopStateDialog.isNeedRefresh,
          job: _vm.currentRow,
          "default-is-expand": _vm.sopStateDialog.defaultIsExpand,
          "is-need-expand": _vm.sopStateDialog.isNeedExpand
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.sopStateDialog, "visible", $event)
          },
          "update:isNeedRefresh": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedRefresh", $event)
          },
          "update:is-need-refresh": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedRefresh", $event)
          },
          "update:isNeedExpand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          "update:is-need-expand": function($event) {
            return _vm.$set(_vm.sopStateDialog, "isNeedExpand", $event)
          },
          handleClose: _vm.sopStateDialogClose
        }
      }),
      _c("estimate-validation-dialog", {
        attrs: {
          visible: _vm.estimateValidationDialog.visible,
          job: _vm.estimateValidationDialog.job,
          "estimate-profit-rate":
            _vm.estimateValidationDialog.estimateProfitRate,
          "tatol-profit": _vm.estimateValidationDialog.tatolProfit
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.estimateValidationDialog, "visible", $event)
          },
          callback: _vm.estimateValidationDialog.callback
        }
      }),
      _vm.checkingSaveJobWindow.visible
        ? _c("checking-save-job-window", {
            attrs: {
              visible: _vm.checkingSaveJobWindow.visible,
              lob: "AI",
              "row-data": _vm.checkingSaveJobWindow.rowData,
              "check-node": _vm.checkingSaveJobWindow.checkNode,
              "call-back": _vm.checkingSaveJobWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingSaveJobWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.trustFromWindow.visible
        ? _c("ai-trust-from-window", {
            attrs: {
              visible: _vm.trustFromWindow.visible,
              "trust-job": _vm.trustFromWindow.trustJob,
              "can-operate-job": _vm.canOperateJob
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.trustFromWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _vm.cooperationBranchListDialog.visible
        ? _c("cooperation-branch-list", {
            attrs: {
              visible: _vm.cooperationBranchListDialog.visible,
              "job-uuid": _vm.cooperationBranchListDialog.jobUuid,
              job: _vm.cooperationBranchListDialog.job,
              "order-center-branch":
                _vm.cooperationBranchListDialog.orderCenterBranch
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.cooperationBranchListDialog,
                  "visible",
                  $event
                )
              },
              refresh: function(cooperatebranch) {
                _vm.updateJobCooperate(cooperatebranch)
                this$1.$refs.tabCharges.refreshCooperatebranch(cooperatebranch)
              },
              cancel: function() {
                return (_vm.cooperationBranchListDialog.visible = false)
              }
            }
          })
        : _vm._e(),
      _vm.jobApplyDialog.visible
        ? _c("job-apply-dialog", {
            attrs: {
              visible: _vm.jobApplyDialog.visible,
              title: _vm.$t("CargoMsg.Cargo_SubmitJobChargeForApproval"),
              type: "apply",
              "doc-id": _vm.currentRow.uuid,
              "document-config-id": _vm.documentConfigId
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.jobApplyDialog, "visible", $event)
              },
              close: function($event) {
                _vm.jobApplyDialog.visible = false
              },
              closeAndRefresh: _vm.applyCloseAndRefresh
            }
          })
        : _vm._e(),
      _c("job-return-review-dialog", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.returnReviewDialog.visible,
            expression: "returnReviewDialog.visible"
          }
        ],
        attrs: {
          visible: _vm.returnReviewDialog.visible,
          lob: "AI",
          "selected-jobs": _vm.returnReviewDialog.selectedJobs,
          srouce: "detail"
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.returnReviewDialog, "visible", $event)
          },
          confirm: _vm.lookHandler
        }
      }),
      _c("data-update-log-dialog", {
        attrs: {
          "hide-window": _vm.isEditing,
          visible: _vm.dataUpdateLogDialog.visible,
          "is-need-refresh": _vm.dataUpdateLogDialog.isNeedRefresh,
          "default-is-expand": _vm.dataUpdateLogDialog.defaultIsExpand,
          job: _vm.job,
          "is-need-expand": _vm.dataUpdateLogDialog.isNeedExpand
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.dataUpdateLogDialog, "visible", $event)
          },
          "update:isNeedExpand": function($event) {
            return _vm.$set(_vm.dataUpdateLogDialog, "isNeedExpand", $event)
          },
          "update:is-need-expand": function($event) {
            return _vm.$set(_vm.dataUpdateLogDialog, "isNeedExpand", $event)
          },
          handleClose: _vm.dataUpdateLogDialogClose
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }